module.exports = __webpack_public_path__ + "static/GT-Haptik-Medium-34661a8be0f17c03f5941aa1dde52dc9.woff2";